import {
  isEqual
} from 'helpers';

export class CatalogueOffer {

  constructor(fields) {

    this.fields = fields;
  }

  nthIndex(string, pattern, nthIndex) {

    const L = string.length;
    let i = -1;

    while (nthIndex-- && i ++ < L) {

        i = string.indexOf(pattern, i);

        if (i < 0)
          break;
    }

    return i;
}

  extractValidity() {
    const sub = this.fields?.description;
    return sub?.substring(sub.lastIndexOf('#') + 1, sub.length);
  }

  extractAdvanceDescription() {
    const sub = this.fields?.description;
    const endPosition = this.nthIndex(sub, '###', 2);
    const startPosition = this.nthIndex(sub, '###', 1) + 3;

    return sub?.substring(startPosition, endPosition);
  }

  extractBuyNowDescription() {
    const sub = this.fields?.description;
    const endPosition = this.nthIndex(sub, '###', 1);
    const startPosition = 0;

    return sub?.substring(startPosition, endPosition);
  }

  extractValue(name) {

    let obj = {};
    const arr = [];

    for (let i = 0; i < this.fields?.prodSpecCharValueUse.length; i ++) {

      const item = this.fields?.prodSpecCharValueUse[i];

      if (isEqual(item?.name, name)) {

        obj['name'] = item?.name;

        for (let j = 0; j < item?.productSpecCharacteristicValue.length; j ++) {

          const element = item?.productSpecCharacteristicValue[j];

          if (isEqual(name, 'Advance Me Payment Terms')) {

            arr.push({
              valueType: element?.valueType,
              typeId: element?.value?.[0]?.option_type_id || element?.value,
              offerId: element?.value?.[0]?.cvasOfferId
            });

            continue;
          }

          const key = element?.valueType?.split(' ').join('_');
          obj[key] = element?.value[0] || element?.value;
        }

        if (arr.length > 0) {
          obj['duration'] = arr;
        }
      }
    }

    return obj;
  }

  mapToStandard() {

    return {
      id: this.fields?.id,
      name: this.fields?.name,
      advanceDescription: this.extractAdvanceDescription(),
      buyNowDescription: this.extractBuyNowDescription(),
      validity: this.extractValidity(),
      url: this.fields?.attachment?.url,
      advance: this.extractValue('AdvanceMe Voucher Value'),
      normal: this.extractValue('Normal Voucher Value'),
      purchaseType: this.extractValue('Advance Me Purchase Type'),
      terms: this.extractValue('Advance Me Payment Terms'),
      retailPrice: this.fields?.productOfferingPrice[0]?.retailPrice?.rand?.amount
    };
  }
}